import styled from 'styled-components';
var PageHeader = styled.div.withConfig({
  displayName: "PageHeader",
  componentId: "ri6t9n-0"
})(["text-align:center;margin-top:20px;font-family:\"Montserrat\",\"Helvetica Neue\",Helvetica,Arial,sans-serif;font-size:300%;"]);
var PageSubheader = styled.h4.withConfig({
  displayName: "PageHeader__PageSubheader",
  componentId: "ri6t9n-1"
})(["margin-top:15px;margin-bottom:20px;text-align:center;"]);
var PageHeaderText = styled.p.withConfig({
  displayName: "PageHeader__PageHeaderText",
  componentId: "ri6t9n-2"
})(["margin-bottom:40px;font-size:125%;"]);
PageHeader.Subheader = PageSubheader;
PageHeader.Text = PageHeaderText;
export default PageHeader;